/**
 * @description tabs
 * @author duanjun
 * @date
 */

import React, { Component } from 'react';
import { classSet } from '@umu/umu-dom';

interface ITabProps {
    index?: number;
    active?: boolean;
    children?: JSX.Element | string | string[];
    onTabChange?: () => void;
}

export default class Tab extends Component<ITabProps, {}> {
    constructor(props: ITabProps) {
        super(props);
    }

    public render() {
        const tabClass = classSet({
            tab: true,
            active: !!this.props.active,
        });

        return (
            <li className={tabClass}>
                <div className="title" data-index={this.props.index} onClick={this.props.onTabChange}>
                    {this.props.children}
                </div>
            </li>
        );
    }
}
